import React from "react";

//material ui
import { useMediaQuery } from "@mui/material";

//components
import CourseModalityCardsMobile from "./CourseModalityCardsMobile";
import CourseModalityCardsDesktop from "./CourseModalityCardsDesktop";

const CourseModalityCards = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  return isMobile ? (
    <CourseModalityCardsMobile />
  ) : (
    <CourseModalityCardsDesktop />
  );
};

export default CourseModalityCards;
